export type FormatPrice = (
  amount: number,
  currencyCode: string,
  locale: string,
  removeZeroDecimals?: boolean,
  useGrouping?: boolean
) => string;

/*
  Always use useExternalFormatPrice hook instead of this one directly
**/
const formatPrice: FormatPrice = (
  amount: number, // 1234.23
  currencyCode: string, // EUR | CAD | ...
  locale: string, // fr-CA | de-DE | en-US | ...
  removeZeroDecimals?: boolean,
  useGrouping = true
): string => {
  const defaultOptions = {
    style: 'currency',
    currency: currencyCode
  };
  const numberFormat = new Intl.NumberFormat(
    locale,
    removeZeroDecimals
      ? { ...defaultOptions, minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping }
      : { ...defaultOptions, useGrouping }
  );
  return numberFormat.format(amount);
};

export default formatPrice;

// Wut? Intl.NumberFormat ???
// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat
